import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import LeftDrawer from "../common/drawerComponent";
import { drawerWidth } from "../common/drawerComponent.entity";
import { useAppSelector } from "../store/hooks";

const PrivateOutlet = () => {
    const auth = useAppSelector((state) => state.auth.loginData);
    const isLeftMenuOpen = useAppSelector((state: any) => state.common.isMenuOpen)

    const [marginLeft, setMarginLeft] = useState(0)

    useEffect(() => {
        if (isLeftMenuOpen === true) {
            setMarginLeft(drawerWidth)
        } else {
            setMarginLeft(0)
        }
    }, [isLeftMenuOpen])

    return auth ? (
        <>
            <LeftDrawer />
            <Box sx={{ pt: 8, marginLeft: { sm: `${marginLeft}px` } }} height='100%' position='relative' >
                {/* <Typography
                    fontSize={{xs: 120 , sm: 150}}
                    color='rgba(250,250,250)'
                    letterSpacing={-16}
                    fontFamily='WorkSans-Medium'
                    lineHeight={0.75}
                    p={0}
                    m={0}
                    zIndex={-10}
                    position='absolute'
                    right={0}
                    top={0}
                > identity </Typography> */}
                <Outlet />
            </Box>
        </>
    ) : (
        <Navigate to="/" />
    );
};

export default PrivateOutlet;
